import * as tslib_1 from "tslib";
import { ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { OnInit, ElementRef, Renderer, EventEmitter } from '@angular/core';
import { getValidatorsFromControl } from 'src/app/main/_utils/general-util';
import { ItmAbstractElementRef } from './itm-abstract-element-ref';
import { AutocompleteService } from 'src/app/root/_services/autocomplete.service';
import { GoogleMapsService } from 'src/app/root/_services/google-maps.service';
import { TranslateService } from '@ngx-translate/core';
var ItmAbstractControl = /** @class */ (function (_super) {
    tslib_1.__extends(ItmAbstractControl, _super);
    function ItmAbstractControl(controlContainer, el, _renderer, autocompleteService, googleMapsService, translateService) {
        var _this = _super.call(this, el) || this;
        _this.controlContainer = controlContainer;
        _this._renderer = _renderer;
        _this.autocompleteService = autocompleteService;
        _this.googleMapsService = googleMapsService;
        _this.translateService = translateService;
        _this.id = _this.generateRandomId();
        _this.showValidationOnlyWhenTouched = false;
        _this.forceValidation = false;
        _this.labelActionClick = new EventEmitter();
        _this.onChange = function (_) { };
        _this.onTouched = function () { };
        _this.disabled = false;
        return _this;
    }
    ItmAbstractControl.prototype._labelActionClick = function (event) {
        this.labelActionClick.emit(event);
    };
    ItmAbstractControl.prototype.ngOnInit = function () {
        if (this.controlContainer.control) {
            if (this.controlContainer.control instanceof FormGroup) {
                this.control = this.controlContainer.control.get(this.formControlName);
                this.validators = getValidatorsFromControl(this.control);
            }
            else if (this.controlContainer.control instanceof FormArray) {
                this.control = this.controlContainer.control.controls[this.formControlName];
                this.validators = getValidatorsFromControl(this.control);
            }
        }
    };
    ItmAbstractControl.prototype.generateRandomId = function () {
        return (Math.round((Math.random() * 10000)) * Date.now() + Math.round((Math.random() * 10000))) + "";
    };
    ItmAbstractControl.prototype.isRequired = function () {
        return true;
    };
    ItmAbstractControl.prototype.validate = function (c) {
        this.control = c;
        return c.valid;
    };
    ItmAbstractControl.prototype.showValidationMessage = function () {
        //return this.control ? this.control.invalid && (!this.showValidationOnlyWhenTouched || (this.control.touched && this.showValidationOnlyWhenTouched)) : false;
        return this.control ? this.control.invalid && this.forceValidation : false;
    };
    // get value(): T {
    // 	return this.val;
    // }
    // set value(v) {
    // 	this.val = v;
    // 	this.onChange(v);
    // 	this.onTouched();
    // }
    /**
         * Writes a new value to the element.
         */
    ItmAbstractControl.prototype.writeValue = function (v) {
        this.val = v;
        if (this.getControlRef())
            this._renderer.setElementProperty(this.getControlRef().nativeElement, 'value', this.val);
    };
    /**
     * Registers a callback function that should be called when
     * the control's value changes in the UI.
     */
    ItmAbstractControl.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Registers a callback function that should be called when
     * the control receives a blur event.
     */
    ItmAbstractControl.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * This function is called by the forms API when
     * the control status changes to or from "DISABLED".
     */
    ItmAbstractControl.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return ItmAbstractControl;
}(ItmAbstractElementRef));
export { ItmAbstractControl };
